<script>
  import _ from 'underscore'
  import ItemPage from '../components/ItemPage.vue'
  import ItemList from '../components/ItemList.vue'
  import PageChooser from '../components/PageChooser.vue'
  import Status from '../components/Status.vue'
  import { item, externalItem } from '../components/Item.vue'
  import Vol01 from './Vol01.vue'
  import Vol02 from './Vol02.vue'
  import Vol03 from './Vol03.vue'
  import Vol04 from './Vol04.vue'
  import Vol05 from './Vol05.vue'
  import Vol06 from './Vol06.vue'
  import Jewel01 from './Jewel01.vue'
  import Jewel02 from './Jewel02.vue'
  import Jewel03 from './Jewel03.vue'
  import Jewel04 from './Jewel04.vue'
  import Jewel05 from './Jewel05.vue'
  import Jewel06 from './Jewel06.vue'
  import PriTama01 from './PriTama01.vue'
  import PriTama02 from './PriTama02.vue'
  import PriTama03 from './PriTama03.vue'
  import PriTama04 from './PriTama04.vue'
  import PriTama05 from './PriTama05.vue'
  import PriTama06 from './PriTama06.vue'
  import PAF01 from './PAF01.vue'
  import PAF02 from './PAF02.vue'
  import Promo2019_Events from './Promo2019_Events.vue'
  import KiraKiraPack01 from './KiraKiraPack01.vue'


  /** @typedef {import('../components/Item.vue').ItemInfo} ItemInfo */
  /** @type {ItemInfo[]} */ const itemsVol01 = Vol01.data().items
  /** @type {ItemInfo[]} */ const itemsVol02 = Vol02.data().items
  /** @type {ItemInfo[]} */ const itemsVol03 = Vol03.data().items
  /** @type {ItemInfo[]} */ const itemsVol04 = Vol04.data().items
  /** @type {ItemInfo[]} */ const itemsVol05 = Vol05.data().items
  /** @type {ItemInfo[]} */ const itemsVol06 = Vol06.data().items
  /** @type {ItemInfo[]} */ const itemsJewel01 = Jewel01.data().items
  /** @type {ItemInfo[]} */ const itemsJewel02 = Jewel02.data().items
  /** @type {ItemInfo[]} */ const itemsJewel03 = Jewel03.data().items
  /** @type {ItemInfo[]} */ const itemsJewel04 = Jewel04.data().items
  /** @type {ItemInfo[]} */ const itemsJewel05 = Jewel05.data().items
  /** @type {ItemInfo[]} */ const itemsJewel06 = Jewel06.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama01 = PriTama01.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama02 = PriTama02.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama03 = PriTama03.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama04 = PriTama04.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama05 = PriTama05.data().items
  /** @type {ItemInfo[]} */ const itemsPriTama06 = PriTama06.data().items
  /** @type {ItemInfo[]} */ const itemsPAF01 = PAF01.data().items
  /** @type {ItemInfo[]} */ const itemsPAF02 = PAF02.data().items
  /** @type {ItemInfo[]} */ const itemsPromo2019_Events = Promo2019_Events.data().items
  /** @type {ItemInfo[]} */ const itemsKiraKiraPack01 = KiraKiraPack01.data().items


  export default {
    components: { ItemPage, ItemList, PageChooser, Status },

    data () {
      return {
        date : '2022-03-22',
        items: [

          // [NOTE] プリリズADチャンネル ER
          // ================================================================================

          externalItem(itemsPAF01, 'PAF01-01', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-02', { collection: 'PRADCh' }),


          externalItem(itemsPAF01, 'PAF01-03', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-04', { collection: 'PRADCh' }),


          externalItem(itemsPAF01, 'PAF01-05', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-06', { collection: 'PRADCh' }),


          item({ rare: 'ER', collection: 'PRADCh' }),
          item({ rare: 'ER', collection: 'PRADCh' }),


          // [NOTE] プリリズADチャンネル PR
          // ================================================================================

          externalItem(itemsPAF01, 'PAF01-07', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-08', { collection: 'PRADCh' }),


          externalItem(itemsPAF01, 'PAF01-09', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-10', { collection: 'PRADCh' }),


          externalItem(itemsPAF01, 'PAF01-11', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-12', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-13', { collection: 'PRADCh' }),
          item({ rare: 'PR', collection: 'PRADCh' }),


          // [NOTE] プリリズADチャンネル SR
          // ================================================================================

          externalItem(itemsPAF01, 'PAF01-14', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-15', { collection: 'PRADCh' }),


          externalItem(itemsPAF01, 'PAF01-16', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-17', { collection: 'PRADCh' }),


          externalItem(itemsPAF01, 'PAF01-18', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-19', { collection: 'PRADCh' }),


          item({ rare: 'SR', collection: 'PRADCh' }),
          item({ rare: 'SR', collection: 'PRADCh' }),


          // [NOTE] プリリズADチャンネル R
          // ================================================================================

          externalItem(itemsPAF01, 'PAF01-20', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-21', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-22', { collection: 'PRADCh' }),
          item({ rare: 'R', collection: 'PRADCh' }),


          externalItem(itemsPAF01, 'PAF01-23', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-24', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-25', { collection: 'PRADCh' }),
          item({ rare: 'R', collection: 'PRADCh' }),


          externalItem(itemsPAF01, 'PAF01-26', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-27', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-28', { collection: 'PRADCh' }),
          item({ rare: 'R', collection: 'PRADCh' }),


          externalItem(itemsPAF01, 'PAF01-29', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-30', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-31', { collection: 'PRADCh' }),
          item({ rare: 'R', collection: 'PRADCh' }),


          externalItem(itemsPAF01, 'PAF01-32', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-33', { collection: 'PRADCh' }),
          item({ rare: 'R', collection: 'PRADCh' }),
          item({ rare: 'R', collection: 'PRADCh' }),

          externalItem(itemsPAF01, 'PAF01-34', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-35', { collection: 'PRADCh' }),
          item({ rare: 'R', collection: 'PRADCh' }),
          item({ rare: 'R', collection: 'PRADCh' }),


          externalItem(itemsPAF01, 'PAF01-36', { collection: 'PRADCh' }),
          externalItem(itemsPAF01, 'PAF01-37', { collection: 'PRADCh' }),
          item({ rare: 'R', collection: 'PRADCh' }),
          item({ rare: 'R', collection: 'PRADCh' }),


          // [NOTE] プリリズDMFチャンネル ER
          // ================================================================================

          externalItem(itemsPAF02, 'PAF02-01', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-02', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-03', { collection: 'PRDMFCh' }),
          item({ rare: 'ER', collection: 'PRDMFCh' }),


          externalItem(itemsPAF02, 'PAF02-04', { collection: 'PRDMFCh' }),
          item({ rare: 'ER', collection: 'PRDMFCh' }),
          item({ rare: 'ER', collection: 'PRDMFCh' }),
          item({ rare: 'ER', collection: 'PRDMFCh' }),


          externalItem(itemsPAF02, 'PAF02-05', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-06', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-07', { collection: 'PRDMFCh' }),
          item({ rare: 'ER', collection: 'PRDMFCh' }),


          externalItem(itemsPAF02, 'PAF02-10', { collection: 'PRDMFCh' }),
          item({ rare: 'ER', collection: 'PRDMFCh' }),
          item({ rare: 'ER', collection: 'PRDMFCh' }),
          item({ rare: 'ER', collection: 'PRDMFCh' }),

          externalItem(itemsPAF02, 'PAF02-08', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-09', { collection: 'PRDMFCh' }),
          item({ rare: 'ER', collection: 'PRDMFCh' }),
          item({ rare: 'ER', collection: 'PRDMFCh' }),


          // [NOTE] プリリズDMFチャンネル PR
          // ================================================================================

          externalItem(itemsPAF02, 'PAF02-11', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-12', { collection: 'PRDMFCh' }),
          item({ rare: 'PR', collection: 'PRDMFCh' }),
          item({ rare: 'PR', collection: 'PRDMFCh' }),


          externalItem(itemsPAF02, 'PAF02-13', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-14', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-15', { collection: 'PRDMFCh' }),
          item({ rare: 'PR', collection: 'PRDMFCh' }),


          externalItem(itemsPAF02, 'PAF02-16', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-17', { collection: 'PRDMFCh' }),
          item({ rare: 'PR', collection: 'PRDMFCh' }),
          item({ rare: 'PR', collection: 'PRDMFCh' }),


          externalItem(itemsPAF02, 'PAF02-18', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-19', { collection: 'PRDMFCh' }),
          item({ rare: 'PR', collection: 'PRDMFCh' }),
          item({ rare: 'PR', collection: 'PRDMFCh' }),


          externalItem(itemsPAF02, 'PAF02-20', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-21', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-22', { collection: 'PRDMFCh' }),
          item({ rare: 'PR', collection: 'PRDMFCh' }),


          // [NOTE] プリリズDMFチャンネル SR
          // ================================================================================

          externalItem(itemsPAF02, 'PAF02-23', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-24', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-25', { collection: 'PRDMFCh' }),
          item({ rare: 'SR', collection: 'PRDMFCh' }),


          externalItem(itemsPAF02, 'PAF02-26', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-27', { collection: 'PRDMFCh' }),
          item({ rare: 'SR', collection: 'PRDMFCh' }),
          item({ rare: 'SR', collection: 'PRDMFCh' }),


          externalItem(itemsPAF02, 'PAF02-28', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-29', { collection: 'PRDMFCh' }),
          item({ rare: 'SR', collection: 'PRDMFCh' }),
          item({ rare: 'SR', collection: 'PRDMFCh' }),


          externalItem(itemsPAF02, 'PAF02-30', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-31', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-32', { collection: 'PRDMFCh' }),
          item({ rare: 'SR', collection: 'PRDMFCh' }),


          externalItem(itemsPAF02, 'PAF02-33', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-34', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-35', { collection: 'PRDMFCh' }),
          item({ rare: 'SR', collection: 'PRDMFCh' }),


          externalItem(itemsPAF02, 'PAF02-36', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-37', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-38', { collection: 'PRDMFCh' }),
          item({ rare: 'SR', collection: 'PRDMFCh' }),


          externalItem(itemsPAF02, 'PAF02-39', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-40', { collection: 'PRDMFCh' }),
          item({ rare: 'SR', collection: 'PRDMFCh' }),
          item({ rare: 'SR', collection: 'PRDMFCh' }),


          externalItem(itemsPAF02, 'PAF02-41', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-42', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-43', { collection: 'PRDMFCh' }),
          item({ rare: 'SR', collection: 'PRDMFCh' }),


          externalItem(itemsPAF02, 'PAF02-44', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-45', { collection: 'PRDMFCh' }),
          externalItem(itemsPAF02, 'PAF02-46', { collection: 'PRDMFCh' }),
          item({ rare: 'SR', collection: 'PRDMFCh' }),


          // [NOTE] プリリズRLチャンネル ER
          // ================================================================================

          item({
            collection  : 'PRRLCh',
            id          : 'PAF03-01',
            rare        : 'ER',
            name        : 'ミラクルファンシーレインボードレス',
            imgUrl      : '/images/items/NC-J5-90.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'PAF03-02',
            rare        : 'ER',
            name        : 'ミラクルファンシーレインボーシューズ',
            imgUrl      : '/images/items/NC-J5-91.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'PRRLCh',
            id          : 'PAF03-03',
            rare        : 'ER',
            name        : 'ナイトドリームドレス',
            imgUrl      : '/images/items/NC-J5-92.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'PAF03-04',
            rare        : 'ER',
            name        : 'ナイトドリームリボンシューズ',
            imgUrl      : '/images/items/NC-J5-93.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'PRRLCh',
            id          : 'PAF03-05',
            rare        : 'ER',
            name        : 'レインボーウエディング',
            imgUrl      : '/images/items/NC-J5-94.png',
            kind        : 'ワンピースワンピース',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'PAF03-06',
            rare        : 'ER',
            name        : 'ミラクルレインボーブーツ',
            imgUrl      : '/images/items/NC-J5-95.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          item({
            collection  : 'PRRLCh',
            rare        : 'ER',
          }),
          item({
            collection  : 'PRRLCh',
            rare        : 'ER',
          }),


          item({
            collection  : 'PRRLCh',
            id          : 'PAF03-07',
            rare        : 'ER',
            name        : 'レディアントレインボードレス',
            imgUrl      : '/images/items/NC-J5-96.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 2 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'PAF03-08',
            rare        : 'ER',
            name        : 'レインボーハイヒール',
            imgUrl      : '/images/items/NC-J5-97.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'PAF03-09',
            rare        : 'ER',
            name        : 'プリズムクイーンヘアアクセ',
            imgUrl      : '/images/items/NC-J5-98.png',
            kind        : 'ヘアアクセ',
            color       : '銀',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 1 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            rare        : 'ER',
          }),


          // [NOTE] プリリズRLチャンネル SR
          // ================================================================================

          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-99',
            rare        : 'SR',
            name        : 'セブンスコーデラブリードレスPc',
            imgUrl      : '/images/items/NC-J5-99.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-100',
            rare        : 'SR',
            name        : 'セブンスコーデラブリーシューズP',
            imgUrl      : '/images/items/NC-J5-100.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-101',
            rare        : 'SR',
            name        : 'セブンスコーデポップドレスPc',
            imgUrl      : '/images/items/NC-J5-101.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-102',
            rare        : 'SR',
            name        : 'セブンスコーデポップシューズP',
            imgUrl      : '/images/items/NC-J5-102.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-103',
            rare        : 'SR',
            name        : 'セブンスコーデクールドレスPc',
            imgUrl      : '/images/items/NC-J5-103.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-104',
            rare        : 'SR',
            name        : 'セブンスコーデクールシューズP',
            imgUrl      : '/images/items/NC-J5-104.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-105',
            rare        : 'SR',
            name        : 'セブンスコーデセクシードレスPc',
            imgUrl      : '/images/items/NC-J5-105.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-106',
            rare        : 'SR',
            name        : 'セブンスコーデセクシーシューズP',
            imgUrl      : '/images/items/NC-J5-106.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-107',
            rare        : 'SR',
            name        : 'セブンスコーデフェミニンドレスPc',
            imgUrl      : '/images/items/NC-J5-107.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-108',
            rare        : 'SR',
            name        : 'セブンスコーデフェミニンシューズP',
            imgUrl      : '/images/items/NC-J5-108.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-109',
            rare        : 'SR',
            name        : 'セブンスコーデエスニックドレスPc',
            imgUrl      : '/images/items/NC-J5-109.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-110',
            rare        : 'SR',
            name        : 'セブンスコーデエスニックシューズP',
            imgUrl      : '/images/items/NC-J5-110.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-111',
            rare        : 'SR',
            name        : 'セブンスコーデスタードレスPc',
            imgUrl      : '/images/items/NC-J5-111.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-112',
            rare        : 'SR',
            name        : 'セブンスコーデスターシューズP',
            imgUrl      : '/images/items/NC-J5-112.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({ rare: 'SR', collection: 'PRRLCh' }),
          item({ rare: 'SR', collection: 'PRRLCh' }),


          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-113',
            rare        : 'SR',
            name        : 'セブンスコーデラブリードレスB',
            imgUrl      : '/images/items/NC-J5-113.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-114',
            rare        : 'SR',
            name        : 'セブンスコーデラブリーシューズB',
            imgUrl      : '/images/items/NC-J5-114.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-115',
            rare        : 'SR',
            name        : 'セブンスコーデポップドレスB',
            imgUrl      : '/images/items/NC-J5-115.png',
            kind        : 'ワンピース',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-116',
            rare        : 'SR',
            name        : 'セブンスコーデポップシューズB',
            imgUrl      : '/images/items/NC-J5-116.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-117',
            rare        : 'SR',
            name        : 'セブンスコーデクールドレスB',
            imgUrl      : '/images/items/NC-J5-117.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-118',
            rare        : 'SR',
            name        : 'セブンスコーデクールシューズB',
            imgUrl      : '/images/items/NC-J5-118.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-119',
            rare        : 'SR',
            name        : 'セブンスコーデセクシードレスB',
            imgUrl      : '/images/items/NC-J5-119.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-120',
            rare        : 'SR',
            name        : 'セブンスコーデセクシーシューズB',
            imgUrl      : '/images/items/NC-J5-120.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-121',
            rare        : 'SR',
            name        : 'セブンスコーデフェミニンドレスB',
            imgUrl      : '/images/items/NC-J5-121.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-122',
            rare        : 'SR',
            name        : 'セブンスコーデフェミニンシューズB',
            imgUrl      : '/images/items/NC-J5-122.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 5 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-123',
            rare        : 'SR',
            name        : 'セブンスコーデエスニックドレスB',
            imgUrl      : '/images/items/NC-J5-123.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-124',
            rare        : 'SR',
            name        : 'セブンスコーデエスニックシューズB',
            imgUrl      : '/images/items/NC-J5-124.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-125',
            rare        : 'SR',
            name        : 'セブンスコーデスタードレスB',
            imgUrl      : '/images/items/NC-J5-125.png',
            kind        : 'ワンピース',
            color       : '銀',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-126',
            rare        : 'SR',
            name        : 'セブンスコーデスターシューズB',
            imgUrl      : '/images/items/NC-J5-126.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          item({ rare: 'SR', collection: 'PRRLCh' }),
          item({ rare: 'SR', collection: 'PRRLCh' }),


          // [NOTE] プリリズRLチャンネル R
          // ================================================================================

          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-164',
            rare        : 'R',
            name        : 'ハピなるアヒルちゃんワンピ',
            imgUrl      : '/images/items/NC-J5-164.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-165',
            rare        : 'R',
            name        : 'ハピなるアヒルちゃんシューズ',
            imgUrl      : '/images/items/NC-J5-165.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({ rare: 'R', collection: 'PRRLCh' }),
          item({ rare: 'R', collection: 'PRRLCh' }),


          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-166',
            rare        : 'R',
            name        : 'ビューティフルフェザーワンピ',
            imgUrl      : '/images/items/NC-J5-166.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 1000,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-167',
            rare        : 'R',
            name        : 'ビューティフルフェザーパンプス',
            imgUrl      : '/images/items/NC-J5-167.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({ rare: 'R', collection: 'PRRLCh' }),
          item({ rare: 'R', collection: 'PRRLCh' }),


          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-168',
            rare        : 'R',
            name        : 'コズミックアシメトップス',
            imgUrl      : '/images/items/NC-J5-168.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 3 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-169',
            rare        : 'R',
            name        : 'コズミックスペーススカート',
            imgUrl      : '/images/items/NC-J5-169.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-170',
            rare        : 'R',
            name        : 'コズミックアシメブーツ',
            imgUrl      : '/images/items/NC-J5-170.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({ rare: 'R', collection: 'PRRLCh' }),


          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-171',
            rare        : 'R',
            name        : 'コズミックチャイナトップス',
            imgUrl      : '/images/items/NC-J5-171.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 600,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-172',
            rare        : 'R',
            name        : 'コズミックスターショーパン',
            imgUrl      : '/images/items/NC-J5-172.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 550,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-173',
            rare        : 'R',
            name        : 'コズミックタイツ&パンプス',
            imgUrl      : '/images/items/NC-J5-173.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PO',
            point       : 500,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({ rare: 'R', collection: 'PRRLCh' }),


          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-174',
            rare        : 'R',
            name        : 'ロイヤルマニッシュジャケット',
            imgUrl      : '/images/items/NC-J5-174.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 600,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-175',
            rare        : 'R',
            name        : 'ロイヤルマニッシュスマートパンツ',
            imgUrl      : '/images/items/NC-J5-175.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 550,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-176',
            rare        : 'R',
            name        : 'ロイヤルスラッシュパンプス',
            imgUrl      : '/images/items/NC-J5-176.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 500,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({ rare: 'R', collection: 'PRRLCh' }),


          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-177',
            rare        : 'R',
            name        : 'ロイヤルメルヘンプリンセスドレス',
            imgUrl      : '/images/items/NC-J5-177.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 1000,
            numOwned    : { usual: 2 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PRRLCh',
            id          : 'NC-J5-178',
            rare        : 'R',
            name        : 'ロイヤルメルヘンシューズ',
            imgUrl      : '/images/items/NC-J5-178.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : '',
            type        : 'LO',
            point       : 500,
            numOwned    : { usual: 4 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({ rare: 'R', collection: 'PRRLCh' }),
          item({ rare: 'R', collection: 'PRRLCh' }),


          // [NOTE] プリズムボイスチャンネル ER
          // ================================================================================

          externalItem(itemsPAF01, 'PAF01-38', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-39', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-40', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-41', { collection: 'PrismVoiceCh' }),


          externalItem(itemsPAF01, 'PAF01-42', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-43', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-44', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-45', { collection: 'PrismVoiceCh' }),


          // [NOTE] プリズムボイスチャンネル PR
          // ================================================================================

          externalItem(itemsPAF01, 'PAF01-46', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-47', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-48', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-49', { collection: 'PrismVoiceCh' }),


          externalItem(itemsPAF01, 'PAF01-50', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-51', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-52', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-53', { collection: 'PrismVoiceCh' }),


          externalItem(itemsPAF01, 'PAF01-54', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-58', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-56', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-57', { collection: 'PrismVoiceCh' }),


          item({ rare: 'PR', collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-55', { collection: 'PrismVoiceCh' }),
          item({ rare: 'PR', collection: 'PrismVoiceCh' }),
          item({ rare: 'PR', collection: 'PrismVoiceCh' }),


          // [NOTE] プリズムボイスチャンネル SR
          // ================================================================================

          externalItem(itemsPAF01, 'PAF01-59', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-60', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-61', { collection: 'PrismVoiceCh' }),
          item({ rare: 'SR', collection: 'PrismVoiceCh' }),


          externalItem(itemsPAF01, 'PAF01-62', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-63', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-64', { collection: 'PrismVoiceCh' }),
          item({ rare: 'SR', collection: 'PrismVoiceCh' }),


          externalItem(itemsPAF01, 'PAF01-65', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-66', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-67', { collection: 'PrismVoiceCh' }),
          item({ rare: 'SR', collection: 'PrismVoiceCh' }),


          externalItem(itemsPAF01, 'PAF01-68', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-69', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-70', { collection: 'PrismVoiceCh' }),
          item({ rare: 'SR', collection: 'PrismVoiceCh' }),


          externalItem(itemsPAF01, 'PAF01-71', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-72', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-73', { collection: 'PrismVoiceCh' }),
          item({ rare: 'SR', collection: 'PrismVoiceCh' }),


          externalItem(itemsPAF01, 'PAF01-74', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-75', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-76', { collection: 'PrismVoiceCh' }),
          item({ rare: 'SR', collection: 'PrismVoiceCh' }),


          externalItem(itemsPAF01, 'PAF01-77', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-78', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-79', { collection: 'PrismVoiceCh' }),
          item({ rare: 'SR', collection: 'PrismVoiceCh' }),


          externalItem(itemsPAF01, 'PAF01-80', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-81', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-82', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-83', { collection: 'PrismVoiceCh' }),


          externalItem(itemsPAF01, 'PAF01-84', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-85', { collection: 'PrismVoiceCh' }),
          externalItem(itemsPAF01, 'PAF01-86', { collection: 'PrismVoiceCh' }),
          item({ rare: 'SR', collection: 'PrismVoiceCh' }),


          // [NOTE] ドリームパレードチャンネル ER
          // ================================================================================

          externalItem(itemsPAF02, 'PAF02-47', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-48', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-49', { collection: 'DreamParadeCh' }),
          item({ rare: 'ER', collection: 'DreamParadeCh' }),


          externalItem(itemsPAF02, 'PAF02-50', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-51', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-52', { collection: 'DreamParadeCh' }),
          item({ rare: 'ER', collection: 'DreamParadeCh' }),


          externalItem(itemsPAF02, 'PAF02-53', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-54', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-55', { collection: 'DreamParadeCh' }),
          item({ rare: 'ER', collection: 'DreamParadeCh' }),


          externalItem(itemsPAF02, 'PAF02-56', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-57', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-58', { collection: 'DreamParadeCh' }),
          item({ rare: 'ER', collection: 'DreamParadeCh' }),


          externalItem(itemsPAF02, 'PAF02-59', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-60', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-61', { collection: 'DreamParadeCh' }),
          item({ rare: 'ER', collection: 'DreamParadeCh' }),


          // [NOTE] ドリームパレードチャンネル PR
          // ================================================================================

          externalItem(itemsPAF02, 'PAF02-62', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-63', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-64', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-65', { collection: 'DreamParadeCh' }),


          externalItem(itemsPAF02, 'PAF02-66', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-67', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-68', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-69', { collection: 'DreamParadeCh' }),


          externalItem(itemsPAF02, 'PAF02-70', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-71', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-72', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-73', { collection: 'DreamParadeCh' }),


          externalItem(itemsPAF02, 'PAF02-74', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-75', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-76', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-77', { collection: 'DreamParadeCh' }),


          externalItem(itemsPAF02, 'PAF02-78', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-79', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-80', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-81', { collection: 'DreamParadeCh' }),


          // [NOTE] ドリームパレードチャンネル SR
          // ================================================================================

          externalItem(itemsPAF02, 'PAF02-91', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-92', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-93', { collection: 'DreamParadeCh' }),
          item({ rare: 'SR', collection: 'DreamParadeCh' }),


          externalItem(itemsPAF02, 'PAF02-94', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-95', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-96', { collection: 'DreamParadeCh' }),
          item({ rare: 'SR', collection: 'DreamParadeCh' }),


          externalItem(itemsPAF02, 'PAF02-82', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-83', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-84', { collection: 'DreamParadeCh' }),
          item({ rare: 'SR', collection: 'DreamParadeCh' }),


          externalItem(itemsPAF02, 'PAF02-85', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-86', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-87', { collection: 'DreamParadeCh' }),
          item({ rare: 'SR', collection: 'DreamParadeCh' }),


          externalItem(itemsPAF02, 'PAF02-88', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-89', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-90', { collection: 'DreamParadeCh' }),
          item({ rare: 'SR', collection: 'DreamParadeCh' }),


          externalItem(itemsPAF02, 'PAF02-97', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-98', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-99', { collection: 'DreamParadeCh' }),
          item({ rare: 'SR', collection: 'DreamParadeCh' }),


          externalItem(itemsPAF02, 'PAF02-100', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-101', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-102', { collection: 'DreamParadeCh' }),
          externalItem(itemsPAF02, 'PAF02-103', { collection: 'DreamParadeCh' }),


          // [NOTE] 神アイドルチャンネル ER
          // ================================================================================

          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-10',
            rare        : 'ER',
            name        : '神ドレス',
            imgUrl      : '/images/items/PAF03-10.png',
            kind        : 'ワンピース',
            color       : '金',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-11',
            rare        : 'ER',
            name        : '神ヒール',
            imgUrl      : '/images/items/PAF03-11.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-12',
            rare        : 'ER',
            name        : '神ティアラ',
            imgUrl      : '/images/items/PAF03-12.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            rare        : 'ER',
          }),


          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-13',
            rare        : 'ER',
            name        : '神トップス',
            imgUrl      : '/images/items/PAF03-13.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1100,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-14',
            rare        : 'ER',
            name        : '神スカート',
            imgUrl      : '/images/items/PAF03-14.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1050,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-15',
            rare        : 'ER',
            name        : '神シューズ',
            imgUrl      : '/images/items/PAF03-15.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-16',
            rare        : 'ER',
            name        : '神ヘアアクセ',
            imgUrl      : '/images/items/PAF03-16.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-17',
            rare        : 'ER',
            name        : 'ジャニス神トップス',
            imgUrl      : '/images/items/PAF03-17.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 1100,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-18',
            rare        : 'ER',
            name        : 'ジャニス神スカート',
            imgUrl      : '/images/items/PAF03-18.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 1050,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-19',
            rare        : 'ER',
            name        : 'ジャニス神シューズ',
            imgUrl      : '/images/items/PAF03-19.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-20',
            rare        : 'ER',
            name        : 'ジャニス神ヘアアクセ',
            imgUrl      : '/images/items/PAF03-20.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-21',
            rare        : 'ER',
            name        : 'エメラルドエデントップス',
            imgUrl      : '/images/items/PAF03-21.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1100,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-22',
            rare        : 'ER',
            name        : 'エメラルドエデンスカート',
            imgUrl      : '/images/items/PAF03-22.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1050,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-23',
            rare        : 'ER',
            name        : 'エメラルドエデンシューズ',
            imgUrl      : '/images/items/PAF03-23.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-24',
            rare        : 'ER',
            name        : 'エメラルドエデンヘアアクセ',
            imgUrl      : '/images/items/PAF03-24.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          // [NOTE] 神アイドルチャンネル PR
          // ================================================================================

          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-25',
            rare        : 'PR',
            name        : 'スーパーサイリウムトライアングルワンピ',
            imgUrl      : '/images/items/PAF03-25.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1600,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-26',
            rare        : 'PR',
            name        : 'スーパーサイリウムトライアングルシューズ',
            imgUrl      : '/images/items/PAF03-26.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-27',
            rare        : 'PR',
            name        : 'スーパーサイリウムトライアングルヘアアクセ',
            imgUrl      : '/images/items/PAF03-27.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            rare        : 'PR',
          }),


          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-28',
            rare        : 'PR',
            name        : 'スーパーサイリウムノンシュガーワンピ',
            imgUrl      : '/images/items/PAF03-28.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 1600,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-29',
            rare        : 'PR',
            name        : 'スーパーサイリウムノンシュガーシューズ',
            imgUrl      : '/images/items/PAF03-29.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-30',
            rare        : 'PR',
            name        : 'スーパーサイリウムノンシュガーヘアアクセ',
            imgUrl      : '/images/items/PAF03-30.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            rare        : 'PR',
          }),


          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-31',
            rare        : 'PR',
            name        : 'ガァルマゲドンピンクハートトップス',
            imgUrl      : '/images/items/NC-J3-20.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-32',
            rare        : 'PR',
            name        : 'ガァルマゲドンピンクハートスカート',
            imgUrl      : '/images/items/NC-J3-21.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-33',
            rare        : 'PR',
            name        : 'ガァルマゲドンピンクハートシューズ',
            imgUrl      : '/images/items/NC-J3-22.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-34',
            rare        : 'PR',
            name        : 'ガァルマゲドンピンクハートヘアアクセ',
            imgUrl      : '/images/items/NC-J3-23.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-35',
            rare        : 'PR',
            name        : 'はなのプリパリルージュトップス',
            imgUrl      : '/images/items/PAF03-35.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-36',
            rare        : 'PR',
            name        : 'はなのプリパリルージュパンツ',
            imgUrl      : '/images/items/PAF03-36.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'SE',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-37',
            rare        : 'PR',
            name        : 'はなのプリパリルージュシューズ',
            imgUrl      : '/images/items/PAF03-37.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'SE',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-38',
            rare        : 'PR',
            name        : 'はなのプリパリルージュヘアアクセ',
            imgUrl      : '/images/items/PAF03-38.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-39',
            rare        : 'PR',
            name        : 'はなのプリパリブルートップス',
            imgUrl      : '/images/items/PAF03-39.png',
            kind        : 'トップス',
            color       : '青',
            brand       : '',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-40',
            rare        : 'PR',
            name        : 'はなのプリパリブルースカート',
            imgUrl      : '/images/items/PAF03-40.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-41',
            rare        : 'PR',
            name        : 'はなのプリパリブルーシューズ',
            imgUrl      : '/images/items/PAF03-41.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-42',
            rare        : 'PR',
            name        : 'はなのプリパリブルーヘアアクセ',
            imgUrl      : '/images/items/PAF03-42.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-43',
            rare        : 'PR',
            name        : 'トライアングルクーレストワンピ',
            imgUrl      : '/images/items/PB-33.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 1600,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-44',
            rare        : 'PR',
            name        : 'トライアングルクーレストシューズ',
            imgUrl      : '/images/items/PB-34.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-45',
            rare        : 'PR',
            name        : 'トライアングルクーレストヘアアクセ',
            imgUrl      : '/images/items/PB-35.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'KamiIdolCh',
            rare        : 'PR',
          }),


          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-46',
            rare        : 'PR',
            name        : 'トライアングルポップンワンピ',
            imgUrl      : '/images/items/PB-36.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : '',
            type        : 'PO',
            point       : 1600,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-47',
            rare        : 'PR',
            name        : 'トライアングルポップンシューズ',
            imgUrl      : '/images/items/PB-37.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : '',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-48',
            rare        : 'PR',
            name        : 'トライアングルポップンヘアアクセ',
            imgUrl      : '/images/items/PB-38.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : '',
            type        : 'PO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'KamiIdolCh',
            rare        : 'PR',
          }),


          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-49',
            rare        : 'PR',
            name        : 'トライアングルラブリー♡ワンピ',
            imgUrl      : '/images/items/PB-39.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1600,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-50',
            rare        : 'PR',
            name        : 'トライアングルラブリー♡シューズ',
            imgUrl      : '/images/items/PB-40.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-51',
            rare        : 'PR',
            name        : 'トライアングルラブリー♡ヘアアクセ',
            imgUrl      : '/images/items/PB-41.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'KamiIdolCh',
            rare        : 'PR',
          }),


          // [NOTE] 神アイドルチャンネル SR
          // ================================================================================

          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-52',
            rare        : 'SR',
            name        : 'トゥインクルリボンスウィートサイリウムワンピ',
            imgUrl      : '/images/items/PAF03-52.png',
            kind        : 'ワンピース',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-53',
            rare        : 'SR',
            name        : 'トゥインクルリボンスウィートサイリウムシューズ',
            imgUrl      : '/images/items/PAF03-53.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-54',
            rare        : 'SR',
            name        : 'トゥインクルリボンスウィートサイリウムヘアアクセ',
            imgUrl      : '/images/items/PAF03-54.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-55',
            rare        : 'SR',
            name        : 'ディアクラウンサイリウムワンピ',
            imgUrl      : '/images/items/PAF03-55.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'SE',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-56',
            rare        : 'SR',
            name        : 'ディアクラウンサイリウムシューズ',
            imgUrl      : '/images/items/PAF03-56.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'SE',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-57',
            rare        : 'SR',
            name        : 'ディアクラウンサイリウムヘアアクセ',
            imgUrl      : '/images/items/PAF03-57.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : '',
            type        : 'SE',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-58',
            rare        : 'SR',
            name        : 'サニーズーサイリウムワンピ',
            imgUrl      : '/images/items/PAF03-58.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : '',
            type        : 'NT',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-59',
            rare        : 'SR',
            name        : 'サニーズーサイリウムシューズ',
            imgUrl      : '/images/items/PAF03-59.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : '',
            type        : 'NT',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-60',
            rare        : 'SR',
            name        : 'サニーズーサイリウムヘアアクセ',
            imgUrl      : '/images/items/PAF03-60.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : '',
            type        : 'NT',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-61',
            rare        : 'SR',
            name        : 'ガァルマゲドンレッドダイヤトップス',
            imgUrl      : '/images/items/PAF03-61.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-62',
            rare        : 'SR',
            name        : 'ガァルマゲドンレッドダイヤスカート',
            imgUrl      : '/images/items/PAF03-62.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-63',
            rare        : 'SR',
            name        : 'ガァルマゲドンレッドダイヤシューズ',
            imgUrl      : '/images/items/PAF03-63.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'KamiIdolCh',
            id          : 'PAF03-64',
            rare        : 'SR',
            name        : 'ガァルマゲドンレッドダイヤヘアアクセ',
            imgUrl      : '/images/items/PAF03-64.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          // [NOTE] アイドルタイムプリパラチャンネル ER
          // ================================================================================

          item({
            collection  : 'IPPCh',
            id          : 'PAF03-65',
            rare        : 'ER',
            name        : '時のトップス',
            imgUrl      : '/images/items/PAF03-65.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1100,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-66',
            rare        : 'ER',
            name        : '時のスカート',
            imgUrl      : '/images/items/PAF03-66.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 1050,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-67',
            rare        : 'ER',
            name        : '時のシューズ',
            imgUrl      : '/images/items/PAF03-67.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-68',
            rare        : 'ER',
            name        : '時のヘアアクセ',
            imgUrl      : '/images/items/PAF03-68.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'IPPCh',
            id          : 'PAF03-69',
            rare        : 'ER',
            name        : 'ファンタジータイムドリームワンピ',
            imgUrl      : '/images/items/PAF03-69.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-70',
            rare        : 'ER',
            name        : 'ファンタジータイムドリームシューズ',
            imgUrl      : '/images/items/PAF03-70.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-71',
            rare        : 'ER',
            name        : 'ファンタジータイムドリームヘアアクセ',
            imgUrl      : '/images/items/PAF03-71.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : '',
            type        : 'LO',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            rare        : 'ER',
          }),


          item({
            collection  : 'IPPCh',
            id          : 'PAF03-72',
            rare        : 'ER',
            name        : 'ひるのワンピ',
            imgUrl      : '/images/items/PAF03-72.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-73',
            rare        : 'ER',
            name        : 'ひるのシューズ',
            imgUrl      : '/images/items/PAF03-73.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-74',
            rare        : 'ER',
            name        : 'ひるのヘアアクセ',
            imgUrl      : '/images/items/PAF03-74.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            rare        : 'ER',
          }),


          item({
            collection  : 'IPPCh',
            id          : 'PAF03-75',
            rare        : 'ER',
            name        : 'あさのワンピ',
            imgUrl      : '/images/items/PAF03-75.png',
            kind        : 'ワンピース',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-76',
            rare        : 'ER',
            name        : 'あさのシューズ',
            imgUrl      : '/images/items/PAF03-76.png',
            kind        : 'シューズ',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-77',
            rare        : 'ER',
            name        : 'あさのヘアアクセ',
            imgUrl      : '/images/items/PAF03-77.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            rare        : 'ER',
          }),


          item({
            collection  : 'IPPCh',
            id          : 'PAF03-78',
            rare        : 'ER',
            name        : 'よるのワンピ',
            imgUrl      : '/images/items/PAF03-78.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-79',
            rare        : 'ER',
            name        : 'よるのシューズ',
            imgUrl      : '/images/items/PAF03-79.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-80',
            rare        : 'ER',
            name        : 'よるのヘアアクセ',
            imgUrl      : '/images/items/PAF03-80.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            rare        : 'ER',
          }),


          // [NOTE] アイドルタイムプリパラチャンネル PR
          // ================================================================================

          item({
            collection  : 'IPPCh',
            id          : 'PAF03-81',
            rare        : 'PR',
            name        : 'ラビットハートミントトップス',
            imgUrl      : '/images/items/PAF03-81.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-82',
            rare        : 'PR',
            name        : 'ラビットハートミントスカート',
            imgUrl      : '/images/items/PAF03-82.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-83',
            rare        : 'PR',
            name        : 'ラビットハートミントシューズ',
            imgUrl      : '/images/items/PAF03-83.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-84',
            rare        : 'PR',
            name        : 'ラビットハートミントヘアアクセ',
            imgUrl      : '/images/items/PAF03-84.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          item({
            collection  : 'IPPCh',
            id          : 'PAF03-85',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムあろまワンピ',
            imgUrl      : '/images/items/PAF03-85.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 1600,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-86',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムあろまシューズ',
            imgUrl      : '/images/items/PAF03-86.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 1 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-87',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムあろまヘアアクセ',
            imgUrl      : '/images/items/PAF03-87.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            rare        : 'PR',
          }),


          item({
            collection  : 'IPPCh',
            id          : 'PAF03-88',
            rare        : 'PR',
            name        : 'ゴールデンフェザートップス',
            imgUrl      : '/images/items/PAF03-88.png',
            kind        : 'トップス',
            color       : '金',
            brand       : '',
            type        : 'SE',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-89',
            rare        : 'PR',
            name        : 'ゴールデンフェザースカート',
            imgUrl      : '/images/items/PAF03-89.png',
            kind        : 'ボトムス',
            color       : '金',
            brand       : '',
            type        : 'SE',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-90',
            rare        : 'PR',
            name        : 'ゴールデンフェザーシューズ',
            imgUrl      : '/images/items/PAF03-90.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : '',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-91',
            rare        : 'PR',
            name        : 'ゴールデンフェザーヘアアクセ',
            imgUrl      : '/images/items/PAF03-91.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : '',
            type        : 'SE',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'IPPCh',
            id          : 'PAF03-92',
            rare        : 'PR',
            name        : 'レインボーパープルパフェトップス',
            imgUrl      : '/images/items/PAF03-92.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-93',
            rare        : 'PR',
            name        : 'レインボーパープルパフェスカート',
            imgUrl      : '/images/items/PAF03-93.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-94',
            rare        : 'PR',
            name        : 'レインボーパープルパフェシューズ',
            imgUrl      : '/images/items/PAF03-94.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-95',
            rare        : 'PR',
            name        : 'レインボーパープルパフェヘアアクセ',
            imgUrl      : '/images/items/PAF03-95.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
            unnecessary : false,
          }),


          item({
            collection  : 'IPPCh',
            id          : 'PAF03-96',
            rare        : 'PR',
            name        : 'レインボーブルースマイルトップス',
            imgUrl      : '/images/items/SLJ3-26.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 850,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-97',
            rare        : 'PR',
            name        : 'レインボーブルースマイルスカート',
            imgUrl      : '/images/items/SLJ3-27.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 900,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-98',
            rare        : 'PR',
            name        : 'レインボーブルースマイルシューズ',
            imgUrl      : '/images/items/SLJ3-28.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-99',
            rare        : 'PR',
            name        : 'レインボーブルースマイルヘアアクセ',
            imgUrl      : '/images/items/SLJ3-29.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          // [NOTE] アイドルタイムプリパラチャンネル SR
          // ================================================================================

          item({
            collection  : 'IPPCh',
            id          : 'PAF03-100',
            rare        : 'SR',
            name        : 'ファンタジータイムサイリウムワンピ',
            imgUrl      : '/images/items/PAF03-100.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-101',
            rare        : 'SR',
            name        : 'ファンタジータイムサイリウムシューズ',
            imgUrl      : '/images/items/PAF03-101.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-102',
            rare        : 'SR',
            name        : 'ファンタジータイムサイリウムヘアアクセ',
            imgUrl      : '/images/items/PAF03-102.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'IPPCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'IPPCh',
            id          : 'PAF03-103',
            rare        : 'SR',
            name        : 'ネオンドロップサイリウムワンピ',
            imgUrl      : '/images/items/PAF03-103.png',
            kind        : 'ワンピース',
            color       : '橙',
            brand       : '',
            type        : 'PO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-104',
            rare        : 'SR',
            name        : 'ネオンドロップサイリウムシューズ',
            imgUrl      : '/images/items/PAF03-104.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-105',
            rare        : 'SR',
            name        : 'ネオンドロップサイリウムヘアアクセ',
            imgUrl      : '/images/items/PAF03-105.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'PO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'IPPCh',
            id          : 'PAF03-106',
            rare        : 'SR',
            name        : 'メルティリリィサイリウムワンピ',
            imgUrl      : '/images/items/PAF03-106.png',
            kind        : 'ワンピース',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-107',
            rare        : 'SR',
            name        : 'メルティリリィサイリウムシューズ',
            imgUrl      : '/images/items/PAF03-107.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-108',
            rare        : 'SR',
            name        : 'メルティリリィサイリウムヘアアクセ',
            imgUrl      : '/images/items/PAF03-108.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : '',
            type        : 'CO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'IPPCh',
            id          : 'PAF03-109',
            rare        : 'SR',
            name        : 'リッチヴィーナスサイリウムワンピ',
            imgUrl      : '/images/items/PAF03-109.png',
            kind        : 'ワンピース',
            color       : '赤',
            brand       : '',
            type        : 'SE',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-110',
            rare        : 'SR',
            name        : 'リッチヴィーナスサイリウムシューズ',
            imgUrl      : '/images/items/PAF03-110.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'SE',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-111',
            rare        : 'SR',
            name        : 'リッチヴィーナスサイリウムヘアアクセ',
            imgUrl      : '/images/items/PAF03-111.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : '',
            type        : 'SE',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'IPPCh',
            id          : 'PAF03-112',
            rare        : 'SR',
            name        : 'アイドルウォッチタンザナイトワンピ',
            imgUrl      : '/images/items/PAF03-112.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-113',
            rare        : 'SR',
            name        : 'アイドルウォッチタンザナイトシューズ',
            imgUrl      : '/images/items/PAF03-113.png',
            kind        : 'シューズ',
            color       : '金',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-114',
            rare        : 'SR',
            name        : 'アイドルウォッチタンザナイトヘアアクセ',
            imgUrl      : '/images/items/PAF03-114.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'IPPCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'IPPCh',
            id          : 'PAF03-115',
            rare        : 'SR',
            name        : 'ラビットハートファンシートップス',
            imgUrl      : '/images/items/PAF03-115.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'LO',
            point       : 700,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-116',
            rare        : 'SR',
            name        : 'ラビットハートファンシースカート',
            imgUrl      : '/images/items/PAF03-116.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 750,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-117',
            rare        : 'SR',
            name        : 'ラビットハートファンシーシューズ',
            imgUrl      : '/images/items/PAF03-117.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-118',
            rare        : 'SR',
            name        : 'ラビットハートファンシーヘアアクセ',
            imgUrl      : '/images/items/PAF03-118.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),


          item({
            collection  : 'IPPCh',
            id          : 'PAF03-123',
            rare        : 'SR',
            name        : 'ギャラティックブルーワンピ',
            imgUrl      : '/images/items/PAF03-123.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-124',
            rare        : 'SR',
            name        : 'ギャラティックブルーシューズ',
            imgUrl      : '/images/items/PAF03-124.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-125',
            rare        : 'SR',
            name        : 'ギャラティックブルーヘアアクセ',
            imgUrl      : '/images/items/PAF03-125.png',
            kind        : 'ヘアアクセ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'IPPCh',
            id          : 'PAF03-119',
            rare        : 'SR',
            name        : 'ギャラティックレッドワンピ',
            imgUrl      : '/images/items/PAF03-119.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-120',
            rare        : 'SR',
            name        : 'ギャラティックレッドシューズ',
            imgUrl      : '/images/items/PAF03-120.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            rare        : 'SR',
          }),
          item({
            collection  : 'IPPCh',
            rare        : 'SR',
          }),


          item({
            collection  : 'IPPCh',
            id          : 'PAF03-121',
            rare        : 'SR',
            name        : 'ギャラティックパープルワンピ',
            imgUrl      : '/images/items/PAF03-121.png',
            kind        : 'ワンピース',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 1300,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : true,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            id          : 'PAF03-122',
            rare        : 'SR',
            name        : 'ギャラティックパープルシューズ',
            imgUrl      : '/images/items/PAF03-122.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 650,
            numOwned    : { usual: 0 },
            numReleased : { usual: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'IPPCh',
            rare        : 'SR',
          }),
          item({
            collection  : 'IPPCh',
            rare        : 'SR',
          }),


          // [NOTE] キラッとアイドルチャンネル KR
          // ================================================================================

          externalItem(itemsVol01, 'PCH1-01', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-02', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-03', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol02, 'PCH2-01', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-02', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-03', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol02, 'PCH2-04', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-05', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-06', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol03, 'PCH3-01', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-02', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-03', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol03, 'PCH3-04', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-05', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-06', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol04, 'PCH4-01', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-02', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-03', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol05, 'PCH5-01', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-02', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-03', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol04, 'PCH4-62', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-63', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-64', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol05, 'PCH5-67', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-68', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-69', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          externalItem(itemsVol06, 'PCH6-01', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-02', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-03', { collection: 'KirattoIdol' }),
          item({ collection: 'KirattoIdol', rare: 'KR' }),


          // [NOTE] キラッとアイドルチャンネル PR
          // ================================================================================

          externalItem(itemsVol01, 'PCH1-12', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-13', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-14', { collection: 'KirattoIdol' }),
          externalItem(itemsVol01, 'PCH1-15', { collection: 'KirattoIdol' }),


          externalItem(itemsVol02, 'PCH2-07', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-11', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-09', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-10', { collection: 'KirattoIdol' }),


          externalItem(itemsVol02, 'PCH2-16', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-17', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-18', { collection: 'KirattoIdol' }),
          externalItem(itemsVol02, 'PCH2-19', { collection: 'KirattoIdol' }),


          externalItem(itemsVol03, 'PCH3-07', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-08', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-09', { collection: 'KirattoIdol' }),
          externalItem(itemsVol03, 'PCH3-10', { collection: 'KirattoIdol' }),


          externalItem(itemsVol04, 'PCH4-08', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-09', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-10', { collection: 'KirattoIdol' }),
          externalItem(itemsVol04, 'PCH4-11', { collection: 'KirattoIdol' }),


          externalItem(itemsVol05, 'PCH5-08', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-09', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-10', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'PCH5-11', { collection: 'KirattoIdol' }),


          externalItem(itemsVol06, 'PCH6-04', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-05', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-06', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-07', { collection: 'KirattoIdol' }),


          externalItem(itemsVol06, 'PCH6-90', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-91', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-92', { collection: 'KirattoIdol' }),
          externalItem(itemsVol06, 'PCH6-93', { collection: 'KirattoIdol' }),


          // [NOTE] キラッとアイドルチャンネル SR
          // ================================================================================

          externalItem(itemsVol05, 'SP-013', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'SP-014', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'SP-015', { collection: 'KirattoIdol' }),
          externalItem(itemsVol05, 'SP-016', { collection: 'KirattoIdol' }),


          // [NOTE] ジュエルアイドルチャンネル JR
          // ================================================================================

          externalItem(itemsJewel01, 'JR1-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel01, 'JR1-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel01, 'JR1-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel02, 'JR2-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel02, 'JR2-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel02, 'JR2-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel02, 'JR3-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel02, 'JR3-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel02, 'JR3-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel03, 'JR4-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel03, 'JR4-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel03, 'JR4-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel03, 'JR5-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel03, 'JR5-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel03, 'JR5-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel04, 'JR6-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel04, 'JR6-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel04, 'JR6-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel04, 'JR7-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel04, 'JR7-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel04, 'JR7-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel05, 'JR8-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'JR8-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'JR8-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel05, 'JR9-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'JR9-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'JR9-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel06, 'JR10-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel06, 'JR10-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel06, 'JR10-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel06, 'JR11-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel06, 'JR11-02', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel06, 'JR11-03', { collection: 'JewelIdolCh' }),
          item({ rare: 'JR', collection: 'JewelIdolCh' }),


          // [NOTE] ジュエルアイドルチャンネル PR
          // ================================================================================

          externalItem(itemsJewel01, 'J1-08', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel01, 'J1-09', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel01, 'J1-10', { collection: 'JewelIdolCh' }),
          item({ rare: 'PR', collection: 'JewelIdolCh' }),


          externalItem(itemsJewel01, 'J1-68', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel01, 'J1-69', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel01, 'J1-70', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel01, 'J1-71', { collection: 'JewelIdolCh' }),


          externalItem(itemsJewel02, 'J2-68', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel02, 'J2-69', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel02, 'J2-70', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel02, 'J2-71', { collection: 'JewelIdolCh' }),


          externalItem(itemsJewel03, 'J3-07', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel03, 'J3-08', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel03, 'J3-09', { collection: 'JewelIdolCh' }),
          item({ rare: 'PR', collection: 'JewelIdolCh' }),

          externalItem(itemsJewel03, 'J3-10', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel03, 'J3-11', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel03, 'J3-12', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel03, 'J3-13', { collection: 'JewelIdolCh' }),


          externalItem(itemsJewel04, 'J4-102', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel04, 'J4-103', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel04, 'J4-104', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel04, 'J4-105', { collection: 'JewelIdolCh' }),


          externalItem(itemsJewel05, 'J5-97', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'J5-98', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'J5-99', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'J5-100', { collection: 'JewelIdolCh' }),


          externalItem(itemsJewel05, 'J5-101', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'J5-102', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'J5-103', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'J5-104', { collection: 'JewelIdolCh' }),


          externalItem(itemsJewel05, 'J5-93', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'J5-94', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'J5-95', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel05, 'J5-96', { collection: 'JewelIdolCh' }),


          externalItem(itemsJewel06, 'J6-11', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel06, 'J6-12', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel06, 'J6-13', { collection: 'JewelIdolCh' }),
          externalItem(itemsJewel06, 'J6-14', { collection: 'JewelIdolCh' }),


          externalItem(itemsPromo2019_Events, 'DF-03', { collection: 'JewelIdolCh' }),
          externalItem(itemsPromo2019_Events, 'DF-01', { collection: 'JewelIdolCh' }),
          externalItem(itemsPromo2019_Events, 'DF-02', { collection: 'JewelIdolCh' }),
          item({ rare: 'PR', collection: 'JewelIdolCh' }),


          // [NOTE] イルミナージュアイドルチャンネル WR
          // ================================================================================

          externalItem(itemsPriTama05, 'PT5-89', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama05, 'PT5-90', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama05, 'PT5-91', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama05, 'PT5-92', { collection: 'ILIdolCh' }),


          externalItem(itemsPriTama05, 'PT5-93', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama05, 'PT5-94', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama05, 'PT5-95', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama05, 'PT5-96', { collection: 'ILIdolCh' }),


          // [NOTE] イルミナージュアイドルチャンネル ER
          // ================================================================================

          externalItem(itemsPriTama01, 'ER1-01', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama01, 'ER1-02', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama01, 'ER1-03', { collection: 'ILIdolCh' }),
          item({ rare: 'ER', collection: 'ILIdolCh' }),


          externalItem(itemsPriTama02, 'ER2-01', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama02, 'ER2-02', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama02, 'ER2-03', { collection: 'ILIdolCh' }),
          item({ rare: 'ER', collection: 'ILIdolCh' }),


          externalItem(itemsPriTama02, 'ER2-10', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama02, 'ER2-11', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama02, 'ER2-12', { collection: 'ILIdolCh' }),
          item({ rare: 'ER', collection: 'ILIdolCh' }),


          externalItem(itemsPriTama03, 'ER3-10', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama03, 'ER3-11', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama03, 'ER3-12', { collection: 'ILIdolCh' }),
          item({ rare: 'ER', collection: 'ILIdolCh' }),


          externalItem(itemsPriTama04, 'ER4-01', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama04, 'ER4-02', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama04, 'ER4-03', { collection: 'ILIdolCh' }),
          item({ rare: 'ER', collection: 'ILIdolCh' }),


          externalItem(itemsPriTama04, 'ER4-07', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama04, 'ER4-08', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama04, 'ER4-09', { collection: 'ILIdolCh' }),
          item({ rare: 'ER', collection: 'ILIdolCh' }),


          externalItem(itemsPriTama05, 'ER5-04', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama05, 'ER5-05', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama05, 'ER5-06', { collection: 'ILIdolCh' }),
          item({ rare: 'ER', collection: 'ILIdolCh' }),


          externalItem(itemsPriTama05, 'ER5-10', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama05, 'ER5-11', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama05, 'ER5-12', { collection: 'ILIdolCh' }),
          item({ rare: 'ER', collection: 'ILIdolCh' }),


          // [NOTE] イルミナージュアイドルチャンネル PR
          // ================================================================================

          externalItem(itemsPriTama01, 'PT1-09', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama01, 'PT1-10', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama01, 'PT1-11', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama01, 'PT1-12', { collection: 'ILIdolCh' }),

          externalItem(itemsPriTama01, 'PT1-17', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama01, 'PT1-18', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama01, 'PT1-19', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama01, 'PT1-20', { collection: 'ILIdolCh' }),


          externalItem(itemsPriTama02, 'PT2-12', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama02, 'PT2-13', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama02, 'PT2-14', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama02, 'PT2-15', { collection: 'ILIdolCh' }),


          externalItem(itemsPriTama02, 'PT2-16', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama02, 'PT2-17', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama02, 'PT2-18', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama02, 'PT2-19', { collection: 'ILIdolCh' }),


          externalItem(itemsPriTama03, 'PT3-09', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama03, 'PT3-10', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama03, 'PT3-11', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama03, 'PT3-12', { collection: 'ILIdolCh' }),


          externalItem(itemsPriTama03, 'PT3-17', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama03, 'PT3-18', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama03, 'PT3-19', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama03, 'PT3-20', { collection: 'ILIdolCh' }),


          externalItem(itemsPriTama04, 'PT4-08', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama04, 'PT4-09', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama04, 'PT4-10', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama04, 'PT4-11', { collection: 'ILIdolCh' }),


          externalItem(itemsPriTama05, 'PT5-09', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama05, 'PT5-10', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama05, 'PT5-11', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama05, 'PT5-12', { collection: 'ILIdolCh' }),


          externalItem(itemsPriTama06, 'PT6-11', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama06, 'PT6-12', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama06, 'PT6-13', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama06, 'PT6-14', { collection: 'ILIdolCh' }),


          externalItem(itemsPriTama06, 'PT6-15', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama06, 'PT6-16', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama06, 'PT6-17', { collection: 'ILIdolCh' }),
          externalItem(itemsPriTama06, 'PT6-18', { collection: 'ILIdolCh' }),


          // [NOTE] イルミナージュコーデ
          // ================================================================================

          externalItem(itemsPriTama01, 'IR01-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama01, 'IR01-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),



          externalItem(itemsPriTama01, 'IR01-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama01, 'IR01-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama02, 'IR02-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama02, 'IR02-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama02, 'IR02-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama02, 'IR02-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama03, 'IR03-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama03, 'IR03-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama03, 'IR03-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama03, 'IR03-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-10', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-11', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-12', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-13', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-14', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-15', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama04, 'IR04-16', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-17', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama04, 'IR04-18', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama05, 'IR05-01', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-02', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-03', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama05, 'IR05-04', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-05', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-06', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          externalItem(itemsPriTama05, 'IR05-07', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-08', { collection: 'ReappearIR' }),
          externalItem(itemsPriTama05, 'IR05-09', { collection: 'ReappearIR' }),
          item({ collection: 'ReappearIR' }),


          // [NOTE] プリティーオールフレンズチャンネル
          // ================================================================================

          externalItem(itemsPAF01, 'PAF01-87', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-88', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-89', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-90', { collection: 'PAFCh' }),


          externalItem(itemsPAF01, 'PAF01-91', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-92', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-93', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-94', { collection: 'PAFCh' }),


          externalItem(itemsPAF01, 'PAF01-95', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-96', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-97', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-98', { collection: 'PAFCh' }),


          externalItem(itemsPAF01, 'PAF01-107', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-108', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-109', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-110', { collection: 'PAFCh' }),


          externalItem(itemsPAF01, 'PAF01-111', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-112', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-113', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-114', { collection: 'PAFCh' }),


          externalItem(itemsPAF01, 'PAF01-103', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-104', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-105', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-106', { collection: 'PAFCh' }),


          externalItem(itemsPAF01, 'PAF01-99', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-100', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-101', { collection: 'PAFCh' }),
          externalItem(itemsPAF01, 'PAF01-102', { collection: 'PAFCh' }),


          externalItem(itemsJewel04  , 'PAF-J4-01', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-02', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-03', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-04', { collection: 'PAFCh' }),


          externalItem(itemsJewel04  , 'PAF-J4-05', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-06', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-07', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsJewel04  , 'PAF-J4-08', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-09', { collection: 'PAFCh' }),
          externalItem(itemsJewel04  , 'PAF-J4-10', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsJewel05  , 'PAF-J5-01', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-02', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-03', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-04', { collection: 'PAFCh' }),


          externalItem(itemsJewel05  , 'PAF-J5-05', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-06', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-07', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-08', { collection: 'PAFCh' }),


          externalItem(itemsJewel05  , 'PAF-J5-09', { collection: 'PAFCh' }),
          externalItem(itemsJewel05  , 'PAF-J5-10', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsPriTama01, 'PT1-113', { collection: 'PAFCh' }),
          externalItem(itemsPriTama01, 'PT1-114', { collection: 'PAFCh' }),
          externalItem(itemsPriTama01, 'PT1-115', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsPriTama01, 'PT1-116', { collection: 'PAFCh' }),
          externalItem(itemsPriTama01, 'PT1-117', { collection: 'PAFCh' }),
          externalItem(itemsPriTama01, 'PT1-118', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsPriTama01, 'PT1-119', { collection: 'PAFCh' }),
          externalItem(itemsPriTama01, 'PT1-120', { collection: 'PAFCh' }),
          externalItem(itemsPriTama01, 'PT1-121', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsPriTama02, 'PT2-118', { collection: 'PAFCh' }),
          externalItem(itemsPriTama02, 'PT2-119', { collection: 'PAFCh' }),
          externalItem(itemsPriTama02, 'PT2-120', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsPriTama02, 'PT2-121', { collection: 'PAFCh' }),
          externalItem(itemsPriTama02, 'PT2-122', { collection: 'PAFCh' }),
          externalItem(itemsPriTama02, 'PT2-123', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          externalItem(itemsPriTama02, 'PT2-124', { collection: 'PAFCh' }),
          externalItem(itemsPriTama02, 'PT2-125', { collection: 'PAFCh' }),
          externalItem(itemsPriTama02, 'PT2-126', { collection: 'PAFCh' }),
          item({ collection: 'PAFCh', rare: 'SR' }),


          // [NOTE] パシャッとアイテムチャンネル
          // ================================================================================

          externalItem(itemsPriTama05, 'PT5-122' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol01    , 'PCH1-66' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol01    , 'PCH1-67' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol01    , 'PCH1-68' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol02    , 'PCH2-68' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol02    , 'PCH2-69' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol03    , 'PCH3-68' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol03    , 'PCH3-70' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol04    , 'PCH4-15' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol04    , 'PCH4-61' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol04    , 'PCH4-81' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'PCH5-20' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'PCH5-86' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'SL5-98'  , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'SL5-99'  , { collection: 'PashaItemCh' }),
          externalItem(itemsVol06    , 'PCH6-24' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol06    , 'PCH6-110', { collection: 'PashaItemCh' }),
          externalItem(itemsJewel01  , 'J1-19'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel01  , 'J1-79'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel02  , 'J2-23'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel02  , 'J2-83'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel03  , 'J3-30'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel03  , 'J3-102'  , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel05  , 'J5-37'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel06  , 'J6-42'   , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama01, 'PT1-46'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama02, 'PT2-44'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama02, 'PB-83'   , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama03, 'PT3-43'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama03, 'PB-91-P' , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama04, 'PB-98'   , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PB-123'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PT5-117' , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PT5-118' , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PT5-119' , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PT5-120' , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PT5-121' , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama05, 'PT5-44'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama06, 'PB-157'  , { collection: 'PashaItemCh' }),
          externalItem(itemsVol01    , 'PCH1-69' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol01    , 'PCH1-70' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol02    , 'PCH2-70' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol02    , 'PCH2-71' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol02    , 'PCH2-72' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol03    , 'PCH3-71' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol03    , 'PCH3-72' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol03    , 'PCH3-73' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol04    , 'PCH4-51' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol04    , 'PCH4-52' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'PCH5-52' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'PCH5-53' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol05    , 'PCH5-54' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol06    , 'PCH6-63' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol06    , 'PCH6-64' , { collection: 'PashaItemCh' }),
          externalItem(itemsVol06    , 'PCH6-65' , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel01  , 'J1-30'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel01  , 'J1-87'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel02  , 'J2-38'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel02  , 'J2-39'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel03  , 'J3-52'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel03  , 'J3-53'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel04  , 'J4-37'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel04  , 'J4-38'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel04  , 'J4-118'  , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel04  , 'J4-119'  , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel04  , 'PB-24'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel05  , 'J5-56'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel05  , 'J5-57'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel05  , 'PB-42'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel06  , 'PB-61'   , { collection: 'PashaItemCh' }),
          externalItem(itemsJewel06  , 'PB-62'   , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama01, 'PT1-51'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama01, 'PT1-52'  , { collection: 'PashaItemCh' }),
          externalItem(itemsPriTama01, 'PB-71'   , { collection: 'PashaItemCh' }),


          // [NOTE] ふっこく！すみっコぐらし＆リラックマチャンネル
          // ================================================================================

          externalItem(itemsJewel05, 'J5-58', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsJewel05, 'J5-59', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsJewel05, 'J5-60', { collection: 'SumikkoRelakuma' }),
          item({ collection: 'SumikkoRelakuma' }),

          externalItem(itemsVol04, 'PCH4-83', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol04, 'PCH4-84', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol04, 'PCH4-85', { collection: 'SumikkoRelakuma' }),
          item({ collection: 'SumikkoRelakuma' }),

          externalItem(itemsVol04, 'PCH4-86', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol04, 'PCH4-87', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol04, 'PCH4-88', { collection: 'SumikkoRelakuma' }),
          item({ collection: 'SumikkoRelakuma' }),

          externalItem(itemsJewel03, 'J3-111' , { collection: 'SumikkoRelakuma' }),
          externalItem(itemsJewel03, 'J3-112' , { collection: 'SumikkoRelakuma' }),
          externalItem(itemsJewel03, 'J3-113' , { collection: 'SumikkoRelakuma' }),
          item({ collection: 'SumikkoRelakuma' }),

          externalItem(itemsJewel03, 'J3-114' , { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol03, 'PCH3-78', { collection: 'SumikkoRelakuma' }),
          item({ collection: 'SumikkoRelakuma' }),
          item({ collection: 'SumikkoRelakuma' }),


          externalItem(itemsVol04, 'PCH4-89', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol04, 'PCH4-90', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol04, 'PCH4-91', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol04, 'PCH4-92', { collection: 'SumikkoRelakuma' }),

          externalItem(itemsVol04, 'PCH4-93', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol04, 'PCH4-94', { collection: 'SumikkoRelakuma' }),
          item({ collection: 'SumikkoRelakuma' }),
          item({ collection: 'SumikkoRelakuma' }),

          externalItem(itemsPriTama02, 'PT2-111', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsPriTama02, 'PT2-112', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsPriTama02, 'PT2-113', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol04, 'PCH4-82', { collection: 'SumikkoRelakuma' }),

          externalItem(itemsPriTama02, 'PT2-114', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsPriTama02, 'PT2-115', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsPriTama02, 'PT2-116', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsPriTama02, 'PT2-117', { collection: 'SumikkoRelakuma' }),

          externalItem(itemsVol06, 'PCH6-80', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol06, 'PCH6-81', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol06, 'PCH6-82', { collection: 'SumikkoRelakuma' }),
          externalItem(itemsVol06, 'PCH6-83', { collection: 'SumikkoRelakuma' }),


          // [NOTE] プリ☆チャンときめきチャンネル
          // ================================================================================

          item({
            collection  : 'PriChanTokimekiCh',
            id          : 'P-190',
            rare        : 'JR',
            name        : 'ブラックダイヤモンドジュエルワンピ',
            imgUrl      : '/images/items/P-NC-005-O.png',
            kind        : '',
            color       : '虹',
            brand       : 'MR',
            type        : 'PO',
            point       : 2000,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PriChanTokimekiCh',
            id          : 'P-191',
            rare        : 'JR',
            name        : 'ブラックダイヤモンドジュエルシューズ',
            imgUrl      : '/images/items/P-NC-005-S.png',
            kind        : '',
            color       : '虹',
            brand       : 'MR',
            type        : 'PO',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PriChanTokimekiCh',
            id          : 'P-192',
            rare        : 'JR',
            name        : 'ブラックダイヤモンドジュエルヘアアクセ',
            imgUrl      : '/images/items/P-NC-005-H.png',
            kind        : '',
            color       : '虹',
            brand       : 'MR',
            type        : 'PO',
            point       : 950,
            numOwned    : { kira: 0 },
            numReleased : { kira: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PriChanTokimekiCh',
            rare        : 'JR',
          }),


          externalItem(itemsVol06, 'P-046', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsVol06, 'P-047', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsVol06, 'P-048', { collection: 'PriChanTokimekiCh' }),
          item({
            collection  : 'PriChanTokimekiCh',
            rare        : 'KR',
          }),


          externalItem(itemsKiraKiraPack01, 'AM-387', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsKiraKiraPack01, 'AM-388', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsKiraKiraPack01, 'AM-389', { collection: 'PriChanTokimekiCh' }),
          item({
            collection  : 'PriChanTokimekiCh',
            rare        : 'RR',
          }),


          externalItem(itemsVol03, 'PCH3-79', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsVol03, 'PCH3-80', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsVol03, 'PCH3-81', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsVol03, 'PCH3-82', { collection: 'PriChanTokimekiCh' }),


          externalItem(itemsJewel01, 'J1-94', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel01, 'J1-95', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel01, 'J1-96', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel01, 'J1-97', { collection: 'PriChanTokimekiCh' }),


          externalItem(itemsJewel02, 'J2-88', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel02, 'J2-89', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel02, 'J2-90', { collection: 'PriChanTokimekiCh' }),
          item({
            collection  : 'PriChanTokimekiCh',
            rare        : 'SR',
          }),


          externalItem(itemsJewel04, 'J4-66', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel04, 'J4-67', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel04, 'J4-68', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel04, 'J4-69', { collection: 'PriChanTokimekiCh' }),


          externalItem(itemsVol03, 'PCH3-83', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsVol03, 'PCH3-84', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsVol03, 'PCH3-85', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsVol03, 'PCH3-86', { collection: 'PriChanTokimekiCh' }),


          externalItem(itemsJewel01, 'J1-57', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel01, 'J1-58', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel01, 'J1-59', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel01, 'J1-60', { collection: 'PriChanTokimekiCh' }),


          externalItem(itemsJewel02, 'J2-53', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel02, 'J2-54', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel02, 'J2-55', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel02, 'J2-56', { collection: 'PriChanTokimekiCh' }),


          externalItem(itemsJewel03, 'J3-119', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel03, 'J3-120', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel03, 'J3-121', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel03, 'J3-122', { collection: 'PriChanTokimekiCh' }),


          externalItem(itemsJewel04, 'J4-78', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel04, 'J4-79', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel04, 'J4-80', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel04, 'J4-81', { collection: 'PriChanTokimekiCh' }),


          externalItem(itemsJewel06, 'J6-121', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel06, 'J6-122', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel06, 'J6-123', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel06, 'J6-124', { collection: 'PriChanTokimekiCh' }),


          externalItem(itemsJewel06, 'J6-117', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel06, 'J6-118', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel06, 'J6-119', { collection: 'PriChanTokimekiCh' }),
          externalItem(itemsJewel06, 'J6-120', { collection: 'PriChanTokimekiCh' }),


          // [NOTE] ニコチケ PR プリティーコレクションその3
          // ================================================================================

          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-01',
            rare        : 'PR',
            name        : 'ノンシュガーふわもこファートップス',
            imgUrl      : '/images/items/NC-PAF03-01.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'NT',
            point       : 800,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-02',
            rare        : 'PR',
            name        : 'ノンシュガーふわもこファースカート',
            imgUrl      : '/images/items/NC-PAF03-02.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'NT',
            point       : 900,
            aggregation : 'NC-F3-01',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-03',
            rare        : 'PR',
            name        : 'ノンシュガーふわもこファーシューズ',
            imgUrl      : '/images/items/NC-PAF03-03.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'NT',
            point       : 850,
            aggregation : 'NC-F3-01',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-04',
            rare        : 'PR',
            name        : 'ノンシュガーふわもこファーヘアアクセ',
            imgUrl      : '/images/items/NC-PAF03-04.png',
            kind        : 'ヘアアクセ',
            color       : '赤',
            brand       : '',
            type        : 'NT',
            point       : 800,
            aggregation : 'NC-F3-01',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-05',
            rare        : 'PR',
            name        : 'ノンシュガーエレガントトップス',
            imgUrl      : '/images/items/NC-PAF03-05.png',
            kind        : 'トップス',
            color       : '青',
            brand       : '',
            type        : 'SE',
            point       : 800,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-06',
            rare        : 'PR',
            name        : 'ノンシュガーエレガントスカート',
            imgUrl      : '/images/items/NC-PAF03-06.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : '',
            type        : 'SE',
            point       : 900,
            aggregation : 'NC-F3-05',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-07',
            rare        : 'PR',
            name        : 'ノンシュガーエレガントシューズ',
            imgUrl      : '/images/items/NC-PAF03-07.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : '',
            type        : 'SE',
            point       : 850,
            aggregation : 'NC-F3-05',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-08',
            rare        : 'PR',
            name        : 'ノンシュガーエレガントヘアアクセ',
            imgUrl      : '/images/items/NC-PAF03-08.png',
            kind        : 'ヘアアクセ',
            color       : '青',
            brand       : '',
            type        : 'SE',
            point       : 800,
            aggregation : 'NC-F3-05',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-09',
            rare        : 'PR',
            name        : 'ノンシュガーガーリーリボントップス',
            imgUrl      : '/images/items/NC-PAF03-09.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-10',
            rare        : 'PR',
            name        : 'ノンシュガーガーリーリボンスカート',
            imgUrl      : '/images/items/NC-PAF03-10.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 900,
            aggregation : 'NC-F3-09',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-11',
            rare        : 'PR',
            name        : 'ノンシュガーガーリーリボンシューズ',
            imgUrl      : '/images/items/NC-PAF03-11.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 850,
            aggregation : 'NC-F3-09',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-12',
            rare        : 'PR',
            name        : 'ノンシュガーガーリーリボンヘアアクセ',
            imgUrl      : '/images/items/NC-PAF03-12.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-F3-09',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-13',
            rare        : 'PR',
            name        : 'はなのプリパリブラントップス',
            imgUrl      : '/images/items/NC-PAF03-13.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'NT',
            point       : 800,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-14',
            rare        : 'PR',
            name        : 'はなのプリパリブランスカート',
            imgUrl      : '/images/items/NC-PAF03-14.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : '',
            type        : 'NT',
            point       : 850,
            aggregation : 'NC-F3-13',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-15',
            rare        : 'PR',
            name        : 'はなのプリパリブランシューズ',
            imgUrl      : '/images/items/NC-PAF03-15.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'NT',
            point       : 900,
            aggregation : 'NC-F3-13',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-16',
            rare        : 'PR',
            name        : 'はなのプリパリブランヘアアクセ',
            imgUrl      : '/images/items/NC-PAF03-16.png',
            kind        : 'ヘアアクセ',
            color       : '白',
            brand       : '',
            type        : 'NT',
            point       : 800,
            aggregation : 'NC-F3-13',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-17',
            rare        : 'PR',
            name        : 'ガァルマゲドンブルークラブトップス',
            imgUrl      : '/images/items/NC-PAF03-17.png',
            kind        : 'トップス',
            color       : '水',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-18',
            rare        : 'PR',
            name        : 'ガァルマゲドンブルークラブスカート',
            imgUrl      : '/images/items/NC-PAF03-18.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'CO',
            point       : 850,
            aggregation : 'NC-F3-17',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-19',
            rare        : 'PR',
            name        : 'ガァルマゲドンブルークラブシューズ',
            imgUrl      : '/images/items/NC-PAF03-19.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'CO',
            point       : 900,
            aggregation : 'NC-F3-17',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-20',
            rare        : 'PR',
            name        : 'ガァルマゲドンブルークラブヘアアクセ',
            imgUrl      : '/images/items/NC-PAF03-20.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : '',
            type        : 'CO',
            point       : 800,
            aggregation : 'NC-F3-17',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-21',
            rare        : 'PR',
            name        : 'マイ☆ドリームミルキーピンクトップス',
            imgUrl      : '/images/items/NC-PAF03-21.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 800,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-22',
            rare        : 'PR',
            name        : 'マイ☆ドリームミルキーピンクスカート',
            imgUrl      : '/images/items/NC-PAF03-22.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 850,
            aggregation : 'NC-F3-21',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-23',
            rare        : 'PR',
            name        : 'マイ☆ドリームミルキーピンクシューズ',
            imgUrl      : '/images/items/NC-PAF03-23.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'LO',
            point       : 900,
            aggregation : 'NC-F3-21',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-24',
            rare        : 'PR',
            name        : 'マイ☆ドリームミルキーピンクヘアアクセ',
            imgUrl      : '/images/items/NC-PAF03-24.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-F3-21',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-25',
            rare        : 'PR',
            name        : 'マイ☆ドリームミルキーグリーントップス',
            imgUrl      : '/images/items/NC-PAF03-25.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'PO',
            point       : 800,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-26',
            rare        : 'PR',
            name        : 'マイ☆ドリームミルキーグリーンスカート',
            imgUrl      : '/images/items/NC-PAF03-26.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 850,
            aggregation : 'NC-F3-25',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-27',
            rare        : 'PR',
            name        : 'マイ☆ドリームミルキーグリーンシューズ',
            imgUrl      : '/images/items/NC-PAF03-27.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PO',
            point       : 900,
            aggregation : 'NC-F3-25',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-28',
            rare        : 'PR',
            name        : 'マイ☆ドリームミルキーグリーンヘアアクセ',
            imgUrl      : '/images/items/NC-PAF03-28.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : '',
            type        : 'PO',
            point       : 800,
            aggregation : 'NC-F3-25',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-29',
            rare        : 'PR',
            name        : 'マイ☆ドリームミルキーイエロートップス',
            imgUrl      : '/images/items/NC-PAF03-29.png',
            kind        : 'トップス',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 800,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-30',
            rare        : 'PR',
            name        : 'マイ☆ドリームミルキーイエロースカート',
            imgUrl      : '/images/items/NC-PAF03-30.png',
            kind        : 'ボトムス',
            color       : '黄',
            brand       : '',
            type        : 'CO',
            point       : 850,
            aggregation : 'NC-F3-29',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-31',
            rare        : 'PR',
            name        : 'マイ☆ドリームミルキーイエローシューズ',
            imgUrl      : '/images/items/NC-PAF03-31.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'CO',
            point       : 900,
            aggregation : 'NC-F3-29',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-32',
            rare        : 'PR',
            name        : 'マイ☆ドリームミルキーイエローヘアアクセ',
            imgUrl      : '/images/items/NC-PAF03-32.png',
            kind        : 'ヘアアクセ',
            color       : '黄',
            brand       : '',
            type        : 'CO',
            point       : 800,
            aggregation : 'NC-F3-29',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-33',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムらぁらワンピ',
            imgUrl      : '/images/items/NC-PAF03-33.png',
            kind        : 'ワンピース',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 1600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-34',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムらぁらシューズ',
            imgUrl      : '/images/items/NC-PAF03-34.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-F3-33',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-35',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムらぁらヘアアクセ',
            imgUrl      : '/images/items/NC-PAF03-35.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : '',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-F3-33',
          }),
          item({
            collection  : 'PrettyCollection3',
            rare        : 'PR',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-36',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムシオンワンピ',
            imgUrl      : '/images/items/NC-PAF03-36.png',
            kind        : 'ワンピース',
            color       : '緑',
            brand       : '',
            type        : 'CO',
            point       : 1600,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-37',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムシオンシューズ',
            imgUrl      : '/images/items/NC-PAF03-37.png',
            kind        : 'シューズ',
            color       : '緑',
            brand       : '',
            type        : 'CO',
            point       : 800,
            aggregation : 'NC-F3-36',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-38',
            rare        : 'PR',
            name        : 'チームスーパーサイリウムシオンヘアアクセ',
            imgUrl      : '/images/items/NC-PAF03-38.png',
            kind        : 'ヘアアクセ',
            color       : '緑',
            brand       : '',
            type        : 'CO',
            point       : 800,
            aggregation : 'NC-F3-36',
          }),
          item({
            collection  : 'PrettyCollection3',
            rare        : 'PR',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E4P-16',
            rare        : 'PR',
            name        : 'ゴーゴースマイルキラッCHUトップス',
            imgUrl      : '/images/items/PT4-16.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 800,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E4P-17',
            rare        : 'PR',
            name        : 'ゴーゴースマイルキラッCHUスカート',
            imgUrl      : '/images/items/PT4-17.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 850,
            aggregation : 'NC-E4P-16',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E4P-18',
            rare        : 'PR',
            name        : 'ゴーゴースマイルキラッCHUシューズ',
            imgUrl      : '/images/items/PT4-18.png',
            kind        : 'シューズ',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 900,
            aggregation : 'NC-E4P-16',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E4P-19',
            rare        : 'PR',
            name        : 'ゴーゴースマイルキラッCHUヘアアクセ',
            imgUrl      : '/images/items/PT4-19.png',
            kind        : 'ヘアアクセ',
            color       : '桃',
            brand       : 'LP',
            type        : 'LO',
            point       : 800,
            aggregation : 'NC-E4P-16',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E4P-01',
            rare        : 'PR',
            name        : 'ゴーゴースマイルメルパントップス',
            imgUrl      : '/images/items/NC-PT4-01.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 850,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E4P-02',
            rare        : 'PR',
            name        : 'ゴーゴースマイルメルパンスカート',
            imgUrl      : '/images/items/NC-PT4-02.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 800,
            aggregation : 'NC-E4P-01',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E4P-03',
            rare        : 'PR',
            name        : 'ゴーゴースマイルメルパンシューズ',
            imgUrl      : '/images/items/NC-PT4-03.png',
            kind        : 'シューズ',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 900,
            aggregation : 'NC-E4P-01',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E4P-04',
            rare        : 'PR',
            name        : 'ゴーゴースマイルメルパンヘアアクセ',
            imgUrl      : '/images/items/NC-PT4-04.png',
            kind        : 'ヘアアクセ',
            color       : '紫',
            brand       : 'LP',
            type        : 'CO',
            point       : 800,
            aggregation : 'NC-E4P-01',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E4P-20',
            rare        : 'PR',
            name        : 'ゴーゴースマイルラビリィトップス',
            imgUrl      : '/images/items/PT4-20.png',
            kind        : 'トップス',
            color       : '水',
            brand       : 'LP',
            type        : 'PO',
            point       : 800,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E4P-21',
            rare        : 'PR',
            name        : 'ゴーゴースマイルラビリィスカート',
            imgUrl      : '/images/items/PT4-21.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : 'LP',
            type        : 'PO',
            point       : 850,
            aggregation : 'NC-E4P-20',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E4P-22',
            rare        : 'PR',
            name        : 'ゴーゴースマイルラビリィシューズ',
            imgUrl      : '/images/items/PT4-22.png',
            kind        : 'シューズ',
            color       : '水',
            brand       : 'LP',
            type        : 'PO',
            point       : 900,
            aggregation : 'NC-E4P-20',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E4P-23',
            rare        : 'PR',
            name        : 'ゴーゴースマイルラビリィヘアアクセ',
            imgUrl      : '/images/items/PT4-23.png',
            kind        : 'ヘアアクセ',
            color       : '水',
            brand       : 'LP',
            type        : 'PO',
            point       : 800,
            aggregation : 'NC-E4P-20',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E4P-12',
            rare        : 'PR',
            name        : 'マスコットソルルトップス',
            imgUrl      : '/images/items/PT4-12.png',
            kind        : 'トップス',
            color       : '橙',
            brand       : 'LP',
            type        : 'NT',
            point       : 800,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E4P-13',
            rare        : 'PR',
            name        : 'マスコットソルルパンツ',
            imgUrl      : '/images/items/PT4-13.png',
            kind        : 'ボトムス',
            color       : '白',
            brand       : 'LP',
            type        : 'NT',
            point       : 900,
            aggregation : 'NC-E4P-12',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E4P-14',
            rare        : 'PR',
            name        : 'マスコットソルルシューズ',
            imgUrl      : '/images/items/PT4-14.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : 'LP',
            type        : 'NT',
            point       : 850,
            aggregation : 'NC-E4P-12',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E4P-15',
            rare        : 'PR',
            name        : 'マスコットソルルヘアアクセ',
            imgUrl      : '/images/items/PT4-15.png',
            kind        : 'ヘアアクセ',
            color       : '橙',
            brand       : 'LP',
            type        : 'NT',
            point       : 800,
            aggregation : 'NC-E4P-12',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E5P-13',
            rare        : 'PR',
            name        : 'マスコットルルナトップス',
            imgUrl      : '/images/items/PT5-13.png',
            kind        : 'トップス',
            color       : '青',
            brand       : 'LP',
            type        : 'SE',
            point       : 800,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E5P-14',
            rare        : 'PR',
            name        : 'マスコットルルナスカート',
            imgUrl      : '/images/items/PT5-14.png',
            kind        : 'ボトムス',
            color       : '青',
            brand       : 'LP',
            type        : 'SE',
            point       : 900,
            aggregation : 'NC-E5P-13',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E5P-15',
            rare        : 'PR',
            name        : 'マスコットルルナシューズ',
            imgUrl      : '/images/items/PT5-15.png',
            kind        : 'シューズ',
            color       : '青',
            brand       : 'LP',
            type        : 'SE',
            point       : 850,
            aggregation : 'NC-E5P-13',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-E5P-16',
            rare        : 'PR',
            name        : 'マスコットルルナヘアアクセ',
            imgUrl      : '/images/items/PT5-16.png',
            kind        : 'ヘアアクセ',
            color       : '金',
            brand       : 'LP',
            type        : 'SE',
            point       : 800,
            aggregation : 'NC-E5P-13',
          }),


          // [NOTE] ニコチケ SR プリティーコレクションその3
          // ================================================================================

          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-39',
            rare        : 'SR',
            name        : 'ドリーミングハーモニージャケット',
            imgUrl      : '/images/items/NC-J5-127.png',
            kind        : 'トップス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-40',
            rare        : 'SR',
            name        : 'ドリーミングハーモニースカート',
            imgUrl      : '/images/items/NC-J5-128.png',
            kind        : 'ボトムス',
            color       : '桃',
            brand       : '',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-F3-39',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-41',
            rare        : 'SR',
            name        : 'ミュージックテクニカルブーツ',
            imgUrl      : '/images/items/NC-J5-129.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-F3-39',
          }),
          item({
            collection  : 'PrettyCollection3',
            rare        : 'SR',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-42',
            rare        : 'SR',
            name        : 'スカイメロディジャケット',
            imgUrl      : '/images/items/NC-J5-130.png',
            kind        : 'トップス',
            color       : '青',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-43',
            rare        : 'SR',
            name        : 'スカイメロディショーパン',
            imgUrl      : '/images/items/NC-J5-131.png',
            kind        : 'ボトムス',
            color       : '水',
            brand       : '',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-F3-42',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-44',
            rare        : 'SR',
            name        : 'ミュージックテクニカルブーツ',
            imgUrl      : '/images/items/NC-J5-129.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-F3-42',
          }),
          item({
            collection  : 'PrettyCollection3',
            rare        : 'SR',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-45',
            rare        : 'SR',
            name        : 'バイオレットノクターンジャケット',
            imgUrl      : '/images/items/NC-J5-133.png',
            kind        : 'トップス',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-46',
            rare        : 'SR',
            name        : 'バイオレットノクターンスカート',
            imgUrl      : '/images/items/NC-J5-134.png',
            kind        : 'ボトムス',
            color       : '紫',
            brand       : '',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-F3-45',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-47',
            rare        : 'SR',
            name        : 'ミュージックテクニカルブーツ',
            imgUrl      : '/images/items/NC-J5-129.png',
            kind        : 'シューズ',
            color       : '白',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-F3-45',
          }),
          item({
            collection  : 'PrettyCollection3',
            rare        : 'SR',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-48',
            rare        : 'SR',
            name        : 'ベルローズワインレッドベアトップ',
            imgUrl      : '/images/items/NC-J5-136.png',
            kind        : 'トップス',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 2 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : false,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-49',
            rare        : 'SR',
            name        : 'ベルローズワインレッドタイトミニ',
            imgUrl      : '/images/items/NC-J5-137.png',
            kind        : 'ボトムス',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-F3-48',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-50',
            rare        : 'SR',
            name        : 'レッドリボンニーハイ&パンプス',
            imgUrl      : '/images/items/NC-J5-138.png',
            kind        : 'シューズ',
            color       : '赤',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-F3-48',
          }),
          item({
            collection  : 'PrettyCollection3',
            rare        : 'SR',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-51',
            rare        : 'SR',
            name        : 'ベルローズシルキーイエローベアトップ',
            imgUrl      : '/images/items/NC-J5-139.png',
            kind        : 'トップス',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 1 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-52',
            rare        : 'SR',
            name        : 'ベルローズシルキーイエローパニエ',
            imgUrl      : '/images/items/NC-J5-140.png',
            kind        : 'スカート',
            color       : '黄',
            brand       : '',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-F3-51',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-53',
            rare        : 'SR',
            name        : 'ブラックリボンパンプス',
            imgUrl      : '/images/items/NC-J5-141.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-F3-51',
          }),
          item({
            collection  : 'PrettyCollection3',
            rare        : 'SR',
          }),


          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-54',
            rare        : 'SR',
            name        : 'ベルローズスパークグリーンベアトップ',
            imgUrl      : '/images/items/NC-J5-142.png',
            kind        : 'トップス',
            color       : '緑',
            brand       : '',
            type        : 'PR',
            point       : 600,
            numOwned    : { nico: 0 },
            numReleased : { nico: 0 },
            isProcured  : false,
            isRecruiting: false,
            unnecessary : true,
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-55',
            rare        : 'SR',
            name        : 'ベルローズスパークグリーンパンツ',
            imgUrl      : '/images/items/NC-J5-143.png',
            kind        : 'ボトムス',
            color       : '緑',
            brand       : '',
            type        : 'PR',
            point       : 550,
            aggregation : 'NC-F3-54',
          }),
          item({
            collection  : 'PrettyCollection3',
            id          : 'NC-F3-56',
            rare        : 'SR',
            name        : 'ブラックリボンパンプス',
            imgUrl      : '/images/items/NC-J5-144.png',
            kind        : 'シューズ',
            color       : '黒',
            brand       : '',
            type        : 'PR',
            point       : 500,
            aggregation : 'NC-F3-54',
          }),
          item({
            collection  : 'PrettyCollection3',
            rare        : 'SR',
          }),


        ]
      }
    },

    computed: {
    },

    methods: {
      collection (collection = '', rare = '') {
        return rare
          ? _.where(this.items, { collection, rare })
          : _.where(this.items, { collection })
      },
    },
  }
</script>


<template>
  <ItemPage :items="items" :narrowCols="[2,11]">

    <template #title>
      <PageChooser />
      <time>{{ date }}</time>
    </template>

    <template #col1>
      <ItemList title="プリリズADCh|🥚 ER 🥚" color="#44cd1f" :items="collection('PRADCh', 'ER')" />
      <ItemList title="プリリズADCh|PR ★★★" color="#ffa1bc" :items="collection('PRADCh', 'PR')" />
      <ItemList title="プリリズADCh|SR ★★" color="#00c7da" :items="collection('PRADCh', 'SR')" />
      <ItemList title="プリリズADCh|R ★" color="#feab0d" :items="collection('PRADCh', 'R')" />
    </template>

    <template #col2>
      <ItemList title="プリリズDMFCh|🥚 ER 🥚" color="#44cd1f" :items="collection('PRDMFCh', 'ER')" />
      <ItemList title="プリリズDMFCh|PR ★★★" color="#ffa1bc" :items="collection('PRDMFCh', 'PR')" />
      <ItemList title="プリリズDMFCh|SR ★★" color="#00c7da" :items="collection('PRDMFCh', 'SR')" />
    </template>

    <template #col3>
      <ItemList title="プリリズRLCh|🥚 ER 🥚" color="#44cd1f" :items="collection('PRRLCh', 'ER')" />
      <ItemList title="プリリズRLCh|PR ★★★" color="#ffa1bc" :items="collection('PRRLCh', 'PR')" />
      <ItemList title="プリリズRLCh|SR ★★" color="#00c7da" :items="collection('PRRLCh', 'SR')" />
      <ItemList title="プリリズRLCh|R ★" color="#feab0d" :items="collection('PRRLCh', 'R')" />
    </template>

    <template #col4>
      <ItemList title="プリズムボイスCh|🥚 ER 🥚" color="#44cd1f" :items="collection('PrismVoiceCh', 'ER')" />
      <ItemList title="プリズムボイスCh|PR ★★★" color="#ffa1bc" :items="collection('PrismVoiceCh', 'PR')" />
      <ItemList title="プリズムボイスCh|SR ★★" color="#00c7da" :items="collection('PrismVoiceCh', 'SR')" />
      <ItemList title="プリズムボイスCh|R ★" color="#feab0d" :items="collection('PrismVoiceCh', 'R')" />
    </template>

    <template #col5>
      <ItemList title="ドリームパレードCh|🥚 ER 🥚" color="#44cd1f" :items="collection('DreamParadeCh', 'ER')" />
      <ItemList title="ドリームパレードCh|PR ★★★" color="#ffa1bc" :items="collection('DreamParadeCh', 'PR')" />
      <ItemList title="ドリームパレードCh|SR ★★" color="#00c7da" :items="collection('DreamParadeCh', 'SR')" />
      <ItemList title="ドリームパレードCh|R ★★" color="#feab0d" :items="collection('DreamParadeCh', 'R')" />
    </template>

    <template #col6>
      <ItemList title="神アイドルCh|🥚 ER 🥚" color="#44cd1f" :items="collection('KamiIdolCh', 'ER')" />
      <ItemList title="神アイドルCh|PR ★★★" color="#ffa1bc" :items="collection('KamiIdolCh', 'PR')" />
      <ItemList title="神アイドルCh|SR ★★" color="#00c7da" :items="collection('KamiIdolCh', 'SR')" />
      <ItemList title="神アイドルCh|R ★" color="#feab0d" :items="collection('KamiIdolCh', 'R')" />
    </template>

    <template #col7>
      <ItemList title="アイドルタイムCh|🥚 ER 🥚" color="#44cd1f" :items="collection('IPPCh', 'ER')" />
      <ItemList title="アイドルタイムCh|PR ★★★" color="#ffa1bc" :items="collection('IPPCh', 'PR')" />
      <ItemList title="アイドルタイムCh|SR ★★" color="#00c7da" :items="collection('IPPCh', 'SR')" />
      <ItemList title="アイドルタイムCh|R ★" color="#feab0d" :items="collection('IPPCh', 'R')" />
    </template>

    <template #col8>
      <ItemList title="キラッとアイドルCH|KR ★★★★" color="#ff5d91" :items="collection('KirattoIdol', 'KR')" />
      <ItemList title="キラッとアイドルCH|PR ★★★" color="#ffa1bc" :items="collection('KirattoIdol', 'PR')" />
      <ItemList title="キラッとアイドルCH|SR ★★" color="#00c7da" :items="collection('KirattoIdol', 'SR')" />
      <ItemList title="キラッとアイドルCH|R ★" color="#feab0d" :items="collection('KirattoIdol', 'R')" />
    </template>

    <template #col9>
      <ItemList title="ジュエルアイドルCH|JR ◆◆◆◆" color="#ff5d91" :items="collection('JewelIdolCh', 'JR')" />
      <ItemList title="ジュエルアイドルCH|PR ★★★" color="#ffa1bc" :items="collection('JewelIdolCh', 'PR')" />
      <ItemList title="ジュエルアイドルCH|SR ★★" color="#00c7da" :items="collection('JewelIdolCh', 'SR')" />
      <ItemList title="ジュエルアイドルCH|R ★" color="#feab0d" :items="collection('JewelIdolCh', 'R')" />
    </template>

    <template #col10>
      <ItemList title="イルミナージュアイドルCH|⭐️ WR ⭐️" color="#ffca59" :items="collection('ILIdolCh', 'WR')" />
      <ItemList title="イルミナージュアイドルCH|🥚 ER 🥚" color="#44cd1f" :items="collection('ILIdolCh', 'ER')" />
      <ItemList title="イルミナージュアイドルCH|PR ★★★" color="#ffa1bc" :items="collection('ILIdolCh', 'PR')" />
      <ItemList title="イルミナージュアイドルCH|SR ★★" color="#00c7da" :items="collection('ILIdolCh', 'SR')" />
    </template>

    <template #col11>
      <ItemList title="イルミナージュコーデ|✨ IR ✨" color="#edd50f" :items="collection('ReappearIR')" />
    </template>

    <template #col12>
      <ItemList title="プリティーオールフレンズ|チャンネル" color="#feab0d" :items="collection('PAFCh')" />
    </template>

    <template #col13>
      <ItemList title="パシャッとアイテム|チャンネル" color="#c598ff" :items="collection('PashaItemCh')" />
    </template>

    <template #col14>
      <ItemList title="ふっこく！すみっコぐらし|＆リラックマチャンネル" color="#a1c0fa" :items="collection('SumikkoRelakuma')" />
    </template>

    <template #col15>
      <ItemList title="プリ☆チャン|ときめきチャンネル" color="#ff5d91" :items="collection('PriChanTokimekiCh', 'JR')" />
      <ItemList title="" color="#ff5d91" :items="collection('PriChanTokimekiCh', 'KR')" />
      <ItemList title="" color="#44cd1f" :items="collection('PriChanTokimekiCh', 'RR')" />
      <ItemList title="" color="#00c7da" :items="collection('PriChanTokimekiCh', 'SR')" />
    </template>

    <template #col16>
      <ItemList title="プリティーコレクション3|ニコチケ PR ★★★" color="#ffa1bc" :items="collection('PrettyCollection3', 'PR')" />
      <ItemList title="プリティーコレクション3|ニコチケ SR ★★" color="#00c7da" :items="collection('PrettyCollection3', 'SR')" />
      <Status :date="date" :items="items" :showKira="true" :showNico="true" />
    </template>

  </ItemPage>
</template>


<style lang="scss" scoped>
  @import '~@/stylesheets/common';

  // PC View: ステータスの表示位置を調整
  .Page ::v-deep .Status {
    // PC View のとき position: absolute になっている (see: ItemPage.vue)
    bottom: 0;
    left: 0;
  }

  // PC View: ステータス表示を置く空間を確保
  // @include iroha-vw-range($from: strip-unit($device-width--pc), $also-apply: print) {
  //   .Page ::v-deep .Page__body {
  //     padding-bottom: $size-unit * 20;
  //   }
  // }
</style>
